export default function clearHiddenFields(values: any) {
  if (Array.isArray(values)) {
    let copy = [...values];
    copy = copy.map((val) => clearHiddenFields(val));
    return copy;
  } else if (typeof values === "object" && values !== null && !(values instanceof Date)) {
    const copy = { ...values };
    Object.keys(copy).forEach((key) => {
      if (copy[key + "Hidden"]) {
        delete copy[key];
      } else {
        copy[key] = clearHiddenFields(copy[key]);
      }
    });
    return copy;
  } else {
    return values;
  }
}
